<template>
	<div>
		<div class="sf-datatable-wrapper">
			<div class="sf-datatable-container">
				<div class="sf-table">
					<table class="qms-table">
						<tbody>
							<tr>
								<!-- 신청처 -->
								<th class="col-1">* {{ getMessage_('QWCC000047') }}</th>
								<td class="col-2">
									<!-- <el-input
										:value="popupSearchParams.rcpt"
										@input="value => setPopupSearchParams_({ key: 'rcpt', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/> -->
									<el-input
										:value="this.detailForm.rcptNm"
										@input="value => setDetailForm({ key: 'rcptNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon"  @click="() => openUserPopup('rcpt')">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rcptTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rcpt')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rcptVisible"
												v-model="rcptValue"
												ref="saveRcptInput"
												size="mini"
												@keyup.enter.native="handleRcptInputConfirm"
												@blur="handleRcptInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRcptInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<!-- 결재 -->
								<th rowspan="3" style="writing-mode: tb-rl; line-height: 120%">{{ getMessage_('QWCC001925') }}</th>
								<!-- 작성 -->
								<th class="col-1">{{ getMessage_('QWCC000056') }}</th>
								<!-- 검토 -->
								<th class="col-1">{{ getMessage_('QWCC000048') }}</th>
								<!-- 승인 -->
								<th class="col-1">{{ getMessage_('QWCC001001') }}</th>
							</tr>
							<tr>
								<!-- 담당부서 -->
								<th>* {{ getMessage_('QWCC000049') }}</th>
								<td class="col-2">
									<el-input
									    :value="this.detailForm.rfpNm"
										@input="value => setDetailForm({ key: 'rfpNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon" @click="() => openUserPopup('rfp')" v-if="!setDisabled">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rfpTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rfp')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rfpVisible"
												v-model="rfpValue"
												ref="saveRfpInput"
												size="mini"
												@keyup.enter.native="handleRfpInputConfirm"
												@blur="handleRfpInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRfpInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<td>{{ detailForm.apcnNm }}</td>
								<td>{{ detailForm.vrfNm }}</td>
								<td>{{ detailForm.csetNm }}</td>
							</tr>
							<tr>
								<!-- 발신처 -->
								<th>{{ getMessage_('QWCC000050') }}</th>
								<td class="col-2">
									<el-input
										:value="this.detailForm.dsprNm"
										:placeholder="getMessage_('QWCC001520')"
										@input="value => setDetailForm_({ key: 'dsprNm', value })"
										readonly
									/>
								</td>
								<td colspan="3">
									<el-input
										:value="this.detailForm.dsprAdr"
										:placeholder="getMessage_('QWCC001521')"
										@input="value => setDetailForm_({ key: 'dsprAdr', value })"
										@keyup.enter.native="checkEmail"
										@blur="checkEmail"
										readonly
									/>
								</td>
								<!-- 메일전송 -->
								<th>{{ getMessage_('QWCC001486') }}</th>
								<td>
									<sf-select-group
										labelPosition="left"
										:inputValue="detailForm.sndStCd"
										:options="detailForm.snStCd !== 'ET_FAIL' ? sndStCdList : getSndStCdListFiltered_"
										:onChange="val => setDetailForm(val, 'sndStCd')"
										:placeholder="getMessage_('QWCC001094')"
										:disabled="detailForm.snStCd !== 'ET_FAIL'"
									/>
								</td>
								<td>{{ detailForm.apcnDd }}</td>
								<td>{{ detailForm.vrfFinDd }}</td>
								<td>{{ detailForm.csetFinDd }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<user-popup :scrId="scrId" ref="userPopupRef" @SendData="closeUserPopup"></user-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import UserPopup from '@qms/comm/commpopup/UserEmailPopup/UserEmailPopupView.vue';

export default {
	data() {
		return {
			rcptMap: new Map(),
			rcptTag: new Array(),
			rcptTracker: 0,
			rcptVisible: false,
			rcptValue: '',
			rfpMap: new Map(),
			rfpTag: new Array(),
			rfpTracker: 0,
			rfpVisible: false,
			rfpValue: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		UserPopup
	},
	mounted() {
		this.setupEmail();
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		setDisabled() {
			return this.detailForm.pgsStCd >= 40 ? true : false;
		}
	},
	watch: {
		rcptTracker() {
			this.setState_({ key: 'rcptInfo', value: this.rcptMap });
			if (this.rcptInfo.size > 0) {
				let rcptNm = '',
					rcptAdr = '';
				for (const [key, val] of this.rcptInfo) {
					rcptNm += val + ';';
					rcptAdr += key + ';';
				}
				this.setDetailForm({ key: 'rcptNm', value: rcptNm.substring(0, rcptNm.length - 1) });
				this.setDetailForm({ key: 'rcptAdr', value: rcptAdr.substring(0, rcptAdr.length - 1) });
			}
		},
		rfpTracker() {
			this.setState_({ key: 'rfpInfo', value: this.rfpMap });
			if (this.rfpInfo.size > 0) {
				let rfpNm = '',
					rfpAdr = '';
				for (const [key, val] of this.rfpInfo) {
					rfpNm += val + ';';
					rfpAdr += key + ';';
				}
				this.setDetailForm({ key: 'rfpNm', value: rfpNm.substring(0, rfpNm.length - 1) });
				this.setDetailForm({ key: 'rfpAdr', value: rfpAdr.substring(0, rfpAdr.length - 1) });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

// 		async setDetailForm(value, key) {
//           this.setDetailForm_({ key, value });
//           this.setState_({ key: 'isSaved', value: true });
//      }, 
		async setDetailForm(payload) {
			this.setDetailForm_(payload);
			this.setState_({ key: 'isSaved', value: true });
		},
		
		openUserPopup(userGbn) {
			this.$refs.userPopupRef.open({ userGbn, userName: this.popupSearchParams[userGbn] });
		},
		closeUserPopup(userList, gubun) {
			for (const user of userList) {
				if (user.email && !this[gubun + 'Map'].has(user.email)) {
					this[gubun + 'Map'].set(user.email, user.userName);
					this[gubun + 'Tag'].push(`<${user.userName}>${user.email}`);
					this[gubun + 'Tracker']++;
				}
			}
			this.setPopupSearchParams_({ key: gubun, value: '' });
		},
		handleClose(tag, idx, gubun) {
			this[gubun + 'Tag'].splice(idx, 1);
			this[gubun + 'Map'].delete(tag.split('>')[1]);
			this[gubun + 'Tracker']--;
		},
		showRcptInput() {
			this.rcptVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRcptInput.$refs.input.focus();
			});
		},
		showRfpInput() {
			this.rfpVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRfpInput.$refs.input.focus();
			});
		},
		handleRcptInputConfirm() {
			const rcptValue = this.rcptValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rcptValue) null;
			else if (regExp.test(rcptValue)) {
				this.rcptTag.push(rcptValue);
				this.rcptMap.set(rcptValue, rcptValue.split('@')[0]);
				this.rcptTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rcptVisible = false;
			this.rcptValue = '';
		},
		handleRfpInputConfirm() {
			const rfpValue = this.rfpValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rfpValue) null;
			else if (regExp.test(rfpValue)) {
				this.rfpTag.push(rfpValue);
				this.rfpMap.set(rfpValue, rfpValue.split('@')[0]);
				this.rfpTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rfpVisible = false;
			this.rfpValue = '';
		},
		checkEmail() {
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (this.detailForm.dsprAdr && !regExp.test(this.detailForm.dsprAdr)) {
				this.setDetailForm_({ key: 'dsprAdr', value: '' });
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
		},
		setupEmail() {
			this.initEmail();

			const dsprId = this.detailForm.dsprId || window.atob(this.user.userId);
			const dsprAdr = this.detailForm.dsprAdr || this.user.email;
			const dsprNm = this.detailForm.dsprNm || this.user.userName;

			this.setDetailForm_({ key: 'dsprId', value: dsprId });
			this.setDetailForm_({ key: 'dsprAdr', value: dsprAdr });
			this.setDetailForm_({ key: 'dsprNm', value: dsprNm });

			//수신자
			const rcptNms = this.detailForm.rcptNm && this.detailForm.rcptNm?.split(';');
			const rcptAdrs = this.detailForm.rcptAdr && this.detailForm.rcptAdr?.split(';');
			//참조자
			const rfpNms = this.detailForm.rfpNm && this.detailForm.rfpNm?.split(';');
			const rfpAdrs = this.detailForm.rfpAdr && this.detailForm.rfpAdr?.split(';');

			if (rcptAdrs?.length) {
				const rcptArrNew = [],
					rcptMapNew = new Map();
				for (let i = 0; i < rcptAdrs.length; i++) {
					rcptArrNew.push(`<${rcptNms[i]}>${rcptAdrs[i]}`);
					rcptMapNew.set(rcptAdrs[i], rcptNms[i]);
				}
				this.setState_({ key: 'rcptInfo', value: rcptMapNew });
				this.rcptTag = rcptArrNew;
				this.rcptMap = rcptMapNew;
				this.rcptTracker += rcptAdrs.length;
			}

			if (rfpAdrs?.length) {
				const rfpArrNew = [],
					rfpMapNew = new Map();

				for (let i = 0; i < rfpAdrs.length; i++) {
					rfpArrNew.push(`<${rfpNms[i]}>${rfpAdrs[i]}`);
					rfpMapNew.set(rfpAdrs[i], rfpNms[i]);
				}

				this.setState_({ key: 'rfpInfo', value: rfpMapNew });
				this.rfpMap = rfpMapNew;
				this.rfpTag = rfpArrNew;
				this.rfpTracker += rfpAdrs.length;
			}
		},
		//이메일 초기화 ref 식으로 부모창에서 써보세요 예시 : 같은 폴더 바로 위 Popup.vue에 있음
		initEmail() {
			this.rcptMap = new Map();
			this.rcptTag = new Array();
			this.rcptTracker = 0;
			this.rcptVisible = false;
			this.rcptValue = '';
			this.rfpMap = new Map();
			this.rfpTag = new Array();
			this.rfpTracker = 0;
			this.rfpVisible = false;
			this.rfpValue = '';
		}
	}
};
</script>
<style lang="scss">
.qms-apcn-tag {
	::-webkit-scrollbar {
		height: 5px !important;
	}
}
.el-tag {
	height: 30px !important;
	line-height: 30px !important;
	margin-left: 5px !important;
}
.el-tag + .el-tag {
	margin-left: 5px !important;
}
.button-new-tag {
	margin-left: 5px !important;
	min-height: 30px !important;
	width: auto !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 3px 15px !important;
	font-size: 12px !important;
	display: inline-block !important;
	border-radius: 4px !important;
}
.input-new-tag {
	width: 350px !important;
	min-width: 350px !important;
	margin-left: 5px !important;
	vertical-align: bottom;
}
</style>
